import { useEffect, useState, useRef } from 'react';
import { useAuthStore } from '../../stores/authStore';

interface AuthInitializerProps {
  children: React.ReactNode;
}

/**
 * Auth initializer component
 * Completes user authentication initialization before rendering children
 * Ensures permission data is loaded before rendering pages
 */
export default function AuthInitializer({ children }: AuthInitializerProps) {
  const [isReady, setIsReady] = useState(false);
  const initializeAuth = useAuthStore(state => state.initializeAuth);
  const initialized = useRef(false);

  useEffect(() => {
    const init = async () => {
      // Prevent duplicate calls caused by React StrictMode
      if (initialized.current) return;
      initialized.current = true;

      // initializeAuth internally checks token validity before calling the API
      await initializeAuth();
      setIsReady(true);
    };

    init();
  }, [initializeAuth]); // initializeAuth is a stable Zustand reference

  // Show loading state
  if (!isReady) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          color: '#6b7280',
        }}
      >
        Loading...
      </div>
    );
  }

  return <>{children}</>;
}
